import { ChangeDetectorRef, Component, inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, OccConfig } from '@spartacus/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { KbWarrantyService } from 'src/app/services/feature/MyWarranty/warranty.service';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import moment from 'moment';
import { LaunchDialogService } from '@spartacus/storefront';
import { KbWarrantySearchDialogComponent } from './kb-warranty-search-dialog/kb-warranty-search-dialog.component';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { WebtrekkConfigService } from 'src/app/webtrekk-config.service';
@Component({
  selector: 'app-warranty-search',
  templateUrl: './warranty-search.component.html',
  styleUrls: ['./warranty-search.component.scss'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class WarrantySearchComponent {
  today: Date;
  warrantyData$: Observable<any> = this.warrantyService.getWarrantySearch();
  ToDate: any;
  FromDate: any;
  EndDate: Date;
  currentDate: Date = new Date();
  bsValue = new Date();
  defaultSoldTo: any;
  searchInput;
  selected: any;
  claimDate: Date;
  warrantyApiData1: any;
  endDateErrorFromApi: string = '';
  startDateErrorFromApi: string = '';
  FormData: any;
  showCustomerList: boolean = false;
  errorForGreaterStartDate: boolean = false;
  errorForGreaterEndDate: boolean = false;

  sortByDate: boolean = false;
  sortByDateDesc: boolean = false;
  sortByNumber: boolean = false;
  sortByNumberDesc: boolean = false;
  sortByClaimNumber: boolean = false;
  sortByClaimNumberDesc: boolean = false;
  sortByStatus: boolean = false;
  sortByStatusDesc: boolean = false;
  sortByMemo: boolean = false;
  sortByMemoDesc: boolean = false;
  sortByAmount: boolean = false;
  sortByAmountDesc: boolean = false;
  sortByCore: boolean = false;
  sortByCoreDesc: boolean = false;
  sortByModel: boolean = false;
  sortByModelDesc: boolean = false;

  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';

  warrantyApiData: any;
  loading$ = new BehaviorSubject<boolean>(true);
  isMobile: boolean = false;
  sub = new Subscription();
  bsconfigDate: string = '';
  platformId = inject(PLATFORM_ID);
  //Method to initialize the form
  warrantyClaimSearchForm = new FormGroup({
    warrantyPartNo: new FormControl(''),
    warrantycustomerPartNo: new FormControl(''),
    warrantyClaimNo: new FormControl(''),
    warrantyClaimRefNo: new FormControl(''),
    claimDateFrom: new FormControl(null, [Validators.required]),
    claimDateTo: new FormControl(null, [Validators.required]),
    showRequestsFromCoworkers: new FormControl(false),
  });
  currentB2bUnitSendToWebtrack !: string;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(
    public warrantyService: KbWarrantyService,
    private globalMsgService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private matdialog: MatDialog,
    private globalMessageService: GlobalMessageService,
    private breakpointObserver: BreakpointObserver,
    protected launchDialogService: LaunchDialogService,
    private config: OccConfig,
    private activeCartService: ActiveCartFacade,
    private webtrekk: WebtrekkConfigService,
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );
  }

  ngOnInit(): void {
    if (this.isMobile) {
      this.setCustomWidth();
    }
    this.getInitialData(true);
  }
  getInitialData(state) {
    this.sub.add(this.warrantyData$.subscribe((x: any) => {
      if (state) {
        this.defaultSoldTo = x.defaultSoldTo;
        this.bsconfigDate = x.dateFormat;
        this.warrantyClaimSearchForm.controls['showRequestsFromCoworkers'].setValue(x?.coWorkerOrders);
      }

      this.ToDate = new Date();
      this.FromDate = new Date(x.startDate);
      this.EndDate = new Date(x.endDate);
      this.loading$.next(false);
    }));
  }
  formatDateCustom(date: Date): string {

    let searchDate = '';
    searchDate = moment(date).format(this.bsconfigDate.toUpperCase());
    return searchDate;
  }
  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'MM/dd/yyyy');
  }

  get warrentyform() {
    return this.warrantyClaimSearchForm.controls;
  }

  // Method to handle form submission
  onSubmit(): void {
    this.errorForGreaterEndDate = false;
    this.errorForGreaterStartDate = false;
    if (this.warrantyClaimSearchForm.valid) {
      this.webtrekk_click();
      this.FormData = {
        defaultSoldTo: this.defaultSoldTo,
        partNo: this.warrantyClaimSearchForm.value.warrantyPartNo
          ? this.warrantyClaimSearchForm.value.warrantyPartNo.trim()
          : '',
        customerPartNo: this.warrantyClaimSearchForm.value.warrantycustomerPartNo
          ? this.warrantyClaimSearchForm.value.warrantycustomerPartNo.trim()
          : '',
        claimNumber: this.warrantyClaimSearchForm.value.warrantyClaimNo
          ? this.warrantyClaimSearchForm.value.warrantyClaimNo.trim()
          : '',
        claimRefNumber: this.warrantyClaimSearchForm.value.warrantyClaimRefNo
          ? this.warrantyClaimSearchForm.value.warrantyClaimRefNo.trim()
          : '',
        startDateString: this.formatDateCustom(this.warrantyClaimSearchForm.value.claimDateFrom),
        endDateString: this.formatDateCustom(this.warrantyClaimSearchForm.value.claimDateTo),
        coWorkerFlag: this.warrantyClaimSearchForm.value.showRequestsFromCoworkers,
      };


      this.postWarrantyData(0, 'byDateDesc');
    } else {
      const status = {
        message: 'common.text_contactusform_submission_error',
      };
      this.globalMessageService.add({ key: status?.message }, GlobalMessageType.MSG_TYPE_ERROR);
      this.sub.add(this.globalMessageService.get().subscribe((x) => {
      }));
    }
  }
  postWarrantyData(currentPage?, sortType?) {
    this.sub.add(this.warrantyService.postWarrantySearch(this.FormData, currentPage, sortType).subscribe((x: any) => {
      if (x?.kbStatusMessageWSDTO?.status == 'error' || x?.kbStatusMessageWSDTO?.status != undefined) {
        this.globalMsgService.add(
          {
            key: x?.kbStatusMessageWSDTO.message,
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );

        if (x?.kbStatusMessageWSDTO?.endDateErrors[0]?.length > 0) {
          this.endDateErrorFromApi = x?.kbStatusMessageWSDTO.endDateErrors[0];
          this.errorForGreaterEndDate = true;
          this.cdr.detectChanges();
        }

        if (x?.kbStatusMessageWSDTO?.startDateErrors[0]?.length > 0) {
          this.startDateErrorFromApi = x?.kbStatusMessageWSDTO.startDateErrors[0];
          this.errorForGreaterStartDate = true;
          this.cdr.detectChanges();
        }
      } else {
        this.warrantyApiData = x;
        this.cdr.detectChanges();
      }
    }));
  }

  openDialog(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = data;

    const dialogRef = this.matdialog.open(KbWarrantySearchDialogComponent, dialogConfig);
  }
  sort(type) {
    this.dateType(type);
    this.claimType(type);
    this.partType(type);
    this.statusType(type);
    this.modelType(type);
    if (type == 'memo') {
      if ((!this.sortByMemo && !this.sortByMemoDesc) || this.sortByMemoDesc) {
        this.postWarrantyData(0, 'byCreditMemo');
        this.sortByMemo = true;
        this.sortByMemoDesc = false;
      } else if (this.sortByMemo) {
        this.postWarrantyData(0, 'byCreditMemoDesc');
        this.sortByMemoDesc = true;
        this.sortByMemo = false;
      }

      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByDate = false;
      this.sortByDate = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
    if (type == 'amount') {
      if ((!this.sortByAmount && !this.sortByAmountDesc) || this.sortByAmountDesc) {
        this.postWarrantyData(0, 'byOrderType');
        this.sortByAmount = true;
        this.sortByAmountDesc = false;
      } else if (this.sortByAmount) {
        this.postWarrantyData(0, 'byOrderTypeDec');
        this.sortByAmount = false;
        this.sortByAmountDesc = true;
      }
      this.sortByCoreDesc = false;
      this.sortByCore = false;
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
    if (type == 'core') {
      if ((!this.sortByCore && !this.sortByCoreDesc) || this.sortByCoreDesc) {
        this.postWarrantyData(0, 'byCoreValue');
        this.sortByCore = true;
        this.sortByCoreDesc = false;
      } else if (this.sortByCore) {
        this.postWarrantyData(0, 'byCoreValueDec');
        this.sortByCoreDesc = true;
        this.sortByCore = false;
      }
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
  }

  dateType(type) {
    if (type == 'date') {
      if ((!this.sortByDate && !this.sortByDateDesc) || this.sortByDateDesc) {
        this.postWarrantyData(0, 'byDate');
        this.sortByDate = true;
        this.sortByDateDesc = false;
      } else if (this.sortByDate) {
        this.postWarrantyData(0, 'byDateDesc');
        this.sortByDateDesc = true;
        this.sortByDate = false;
      }
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
  }

  claimType(type) {
    if (type == 'claim') {
      if ((!this.sortByClaimNumber && !this.sortByClaimNumberDesc) || this.sortByClaimNumberDesc) {
        this.postWarrantyData(0, 'byNumber');
        this.sortByClaimNumber = true;
        this.sortByClaimNumberDesc = false;
      } else if (this.sortByClaimNumber) {
        this.postWarrantyData(0, 'byNumberDesc');
        this.sortByClaimNumberDesc = true;
        this.sortByClaimNumber = false;
      }
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
  }

  partType(type) {
    if (type == 'part') {
      if ((!this.sortByNumber && !this.sortByNumberDesc) || this.sortByNumberDesc) {
        this.postWarrantyData(0, 'byPartNumber');
        this.sortByNumber = true;
        this.sortByNumberDesc = false;
      } else if (this.sortByNumber) {
        this.postWarrantyData(0, 'byPartNumberDesc');
        this.sortByNumberDesc = true;
        this.sortByNumber = false;
      }
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
  }

  statusType(type) {
    if (type == 'status') {
      if ((!this.sortByStatus && !this.sortByStatusDesc) || this.sortByStatusDesc) {
        this.postWarrantyData(0, 'byStatus');
        this.sortByStatus = true;
        this.sortByStatusDesc = false;
      } else if (this.sortByStatus) {
        this.postWarrantyData(0, 'byStatusDesc');
        this.sortByStatusDesc = true;
        this.sortByStatus = false;
      }
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByModel = false;
      this.sortByModelDesc = false;
    }
  }

  modelType(type) {
    if (type == 'model') {
      if ((!this.sortByModel && !this.sortByModelDesc) || this.sortByModelDesc) {
        this.postWarrantyData(0, 'byModel');
        this.sortByModel = true;
        this.sortByModelDesc = false;
      } else if (this.sortByModel) {
        this.postWarrantyData(0, 'byModelDesc');
        this.sortByModelDesc = true;
        this.sortByModel = false;
      }
      this.sortByNumber = false;
      this.sortByNumberDesc = false;
      this.sortByClaimNumber = false;
      this.sortByClaimNumberDesc = false;
      this.sortByStatus = false;
      this.sortByStatusDesc = false;
      this.sortByDate = false;
      this.sortByDateDesc = false;
      this.sortByAmount = false;
      this.sortByAmountDesc = false;
      this.sortByCore = false;
      this.sortByCoreDesc = false;
      this.sortByMemo = false;
      this.sortByMemoDesc = false;
    }
  }
  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }

  receiveData(data: any) {
    this.defaultSoldTo = data;
    this.showCustomerList = false;
    this.getInitialData(false);
  }


  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }
  webtrekk_click() {
    // this.pixel.trackAction(true);
    this.activeCartService.getActive().pipe(
      take(1)
    ).subscribe((item: any) => {
      this.currentB2bUnitSendToWebtrack = item?.currentB2BUnit?.uid;
      this.webtrekk.runWhenReady(() => {
        (window as any).wtSmart?.action?.data?.set({
          name: 'WarrantySearch',
          parameter: {
            7: this.getCountryCode()
          }
        });
        (window as any).wtSmart?.track();
        console.log('[webtrekk] Action tracked:', 'WarrantySearch');
      });
    });

  }
  getCountryCode(): string {
    return isPlatformBrowser(this.platformId) ? window.location.pathname.split('/')[1] : '';
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.sub.unsubscribe();
  }

}
